module.exports={
    "v": "5.6.4",
    "fr": 60,
    "ip": 0,
    "op": 96,
    "w": 100,
    "h": 100,
    "nm": "Arrow",
    "ddd": 0,
    "assets": [],
    "layers": [{
        "ddd": 0,
        "ind": 1,
        "ty": 4,
        "nm": "Shape 254",
        "sr": 1,
        "ks": {
            "o": {
                "a": 0,
                "k": 100,
                "ix": 11
            },
            "r": {
                "a": 0,
                "k": 0,
                "ix": 10
            },
            "p": {
                "a": 0,
                "k": [62.125, 50, 0],
                "ix": 2
            },
            "a": {
                "a": 0,
                "k": [10.5, 21, 0],
                "ix": 1
            },
            "s": {
                "a": 0,
                "k": [100, 100, 100],
                "ix": 6
            }
        },
        "ao": 0,
        "shapes": [{
            "ty": "gr",
            "it": [{
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                    "a": 1,
                    "k": [{
                        "i": {
                            "x": 0,
                            "y": 1
                        },
                        "o": {
                            "x": 0.167,
                            "y": 0
                        },
                        "t": 29,
                        "s": [{
                            "i": [
                                [0, 0],
                                [0, 0],
                                [0, 0]
                            ],
                            "o": [
                                [0, 0],
                                [0, 0],
                                [0, 0]
                            ],
                            "v": [
                                [-5.125, 21],
                                [21, 21],
                                [-5.25, 21]
                            ],
                            "c": false
                        }]
                    }, {
                        "i": {
                            "x": 0.667,
                            "y": 1
                        },
                        "o": {
                            "x": 0.167,
                            "y": 0.167
                        },
                        "t": 82,
                        "s": [{
                            "i": [
                                [0, 0],
                                [0, 0],
                                [0, 0]
                            ],
                            "o": [
                                [0, 0],
                                [0, 0],
                                [0, 0]
                            ],
                            "v": [
                                [0, 42],
                                [21, 21],
                                [0, 0]
                            ],
                            "c": false
                        }]
                    }, {
                        "i": {
                            "x": 0,
                            "y": 1
                        },
                        "o": {
                            "x": 0.333,
                            "y": 0
                        },
                        "t": 439,
                        "s": [{
                            "i": [
                                [0, 0],
                                [0, 0],
                                [0, 0]
                            ],
                            "o": [
                                [0, 0],
                                [0, 0],
                                [0, 0]
                            ],
                            "v": [
                                [0, 42],
                                [21, 21],
                                [0, 0]
                            ],
                            "c": false
                        }]
                    }, {
                        "i": {
                            "x": 0.833,
                            "y": 1
                        },
                        "o": {
                            "x": 0.167,
                            "y": 0
                        },
                        "t": 478,
                        "s": [{
                            "i": [
                                [0, 0],
                                [0, 0],
                                [0, 0]
                            ],
                            "o": [
                                [0, 0],
                                [0, 0],
                                [0, 0]
                            ],
                            "v": [
                                [27, 42],
                                [48, 21],
                                [27, 0]
                            ],
                            "c": false
                        }]
                    }, {
                        "i": {
                            "x": 0,
                            "y": 1
                        },
                        "o": {
                            "x": 0.333,
                            "y": 0
                        },
                        "t": 521,
                        "s": [{
                            "i": [
                                [0, 0],
                                [0, 0],
                                [0, 0]
                            ],
                            "o": [
                                [0, 0],
                                [0, 0],
                                [0, 0]
                            ],
                            "v": [
                                [27, 42],
                                [48, 21],
                                [27, 0]
                            ],
                            "c": false
                        }]
                    }, {
                        "i": {
                            "x": 0.833,
                            "y": 1
                        },
                        "o": {
                            "x": 0.333,
                            "y": 0
                        },
                        "t": 560,
                        "s": [{
                            "i": [
                                [0, 0],
                                [0, 0],
                                [0, 0]
                            ],
                            "o": [
                                [0, 0],
                                [0, 0],
                                [0, 0]
                            ],
                            "v": [
                                [0, 42],
                                [21, 21],
                                [0, 0]
                            ],
                            "c": false
                        }]
                    }, {
                        "i": {
                            "x": 0.833,
                            "y": 1
                        },
                        "o": {
                            "x": 0.167,
                            "y": 0
                        },
                        "t": 1442,
                        "s": [{
                            "i": [
                                [0, 0],
                                [0, 0],
                                [0, 0]
                            ],
                            "o": [
                                [0, 0],
                                [0, 0],
                                [0, 0]
                            ],
                            "v": [
                                [0, 42],
                                [21, 21],
                                [0, 0]
                            ],
                            "c": false
                        }]
                    }, {
                        "i": {
                            "x": 0,
                            "y": 1
                        },
                        "o": {
                            "x": 0.167,
                            "y": 0
                        },
                        "t": 1474,
                        "s": [{
                            "i": [
                                [0, 0],
                                [0, 0],
                                [0, 0]
                            ],
                            "o": [
                                [0, 0],
                                [0, 0],
                                [0, 0]
                            ],
                            "v": [
                                [-5.125, 21],
                                [21, 21],
                                [-5.25, 21]
                            ],
                            "c": false
                        }]
                    }, {
                        "i": {
                            "x": 0.667,
                            "y": 1
                        },
                        "o": {
                            "x": 0.167,
                            "y": 0.167
                        },
                        "t": 1527,
                        "s": [{
                            "i": [
                                [0, 0],
                                [0, 0],
                                [0, 0]
                            ],
                            "o": [
                                [0, 0],
                                [0, 0],
                                [0, 0]
                            ],
                            "v": [
                                [0, 42],
                                [21, 21],
                                [0, 0]
                            ],
                            "c": false
                        }]
                    }, {
                        "i": {
                            "x": 0,
                            "y": 1
                        },
                        "o": {
                            "x": 0.333,
                            "y": 0
                        },
                        "t": 1572,
                        "s": [{
                            "i": [
                                [0, 0],
                                [0, 0],
                                [0, 0]
                            ],
                            "o": [
                                [0, 0],
                                [0, 0],
                                [0, 0]
                            ],
                            "v": [
                                [0, 42],
                                [21, 21],
                                [0, 0]
                            ],
                            "c": false
                        }]
                    }, {
                        "i": {
                            "x": 0.833,
                            "y": 1
                        },
                        "o": {
                            "x": 0.167,
                            "y": 0
                        },
                        "t": 1611,
                        "s": [{
                            "i": [
                                [0, 0],
                                [0, 0],
                                [0, 0]
                            ],
                            "o": [
                                [0, 0],
                                [0, 0],
                                [0, 0]
                            ],
                            "v": [
                                [27, 42],
                                [48, 21],
                                [27, 0]
                            ],
                            "c": false
                        }]
                    }, {
                        "i": {
                            "x": 0,
                            "y": 1
                        },
                        "o": {
                            "x": 0.333,
                            "y": 0
                        },
                        "t": 1654,
                        "s": [{
                            "i": [
                                [0, 0],
                                [0, 0],
                                [0, 0]
                            ],
                            "o": [
                                [0, 0],
                                [0, 0],
                                [0, 0]
                            ],
                            "v": [
                                [27, 42],
                                [48, 21],
                                [27, 0]
                            ],
                            "c": false
                        }]
                    }, {
                        "t": 1693,
                        "s": [{
                            "i": [
                                [0, 0],
                                [0, 0],
                                [0, 0]
                            ],
                            "o": [
                                [0, 0],
                                [0, 0],
                                [0, 0]
                            ],
                            "v": [
                                [0, 42],
                                [21, 21],
                                [0, 0]
                            ],
                            "c": false
                        }]
                    }],
                    "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
            }, {
                "ty": "st",
                "c": {
                    "a": 0,
                    "k": [1, 1, 1, 1],
                    "ix": 3
                },
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 4
                },
                "w": {
                    "a": 0,
                    "k": 3,
                    "ix": 5
                },
                "lc": 2,
                "lj": 2,
                "bm": 0,
                "nm": "Stroke 1",
                "mn": "ADBE Vector Graphic - Stroke",
                "hd": false
            }, {
                "ty": "tr",
                "p": {
                    "a": 0,
                    "k": [0, 0],
                    "ix": 2
                },
                "a": {
                    "a": 0,
                    "k": [0, 0],
                    "ix": 1
                },
                "s": {
                    "a": 0,
                    "k": [100, 100],
                    "ix": 3
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 6
                },
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 7
                },
                "sk": {
                    "a": 0,
                    "k": 0,
                    "ix": 4
                },
                "sa": {
                    "a": 0,
                    "k": 0,
                    "ix": 5
                },
                "nm": "Transform"
            }],
            "nm": "Shape 254",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
        }],
        "ip": 29,
        "op": 3528,
        "st": -72,
        "bm": 0
    }, {
        "ddd": 0,
        "ind": 2,
        "ty": 4,
        "nm": "Shape 253",
        "sr": 1,
        "ks": {
            "o": {
                "a": 0,
                "k": 100,
                "ix": 11
            },
            "r": {
                "a": 0,
                "k": 0,
                "ix": 10
            },
            "p": {
                "a": 0,
                "k": [50.125, 50, 0],
                "ix": 2
            },
            "a": {
                "a": 0,
                "k": [22.5, 0, 0],
                "ix": 1
            },
            "s": {
                "a": 0,
                "k": [100, 100, 100],
                "ix": 6
            }
        },
        "ao": 0,
        "shapes": [{
            "ty": "gr",
            "it": [{
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                    "a": 1,
                    "k": [{
                        "i": {
                            "x": 0,
                            "y": 1
                        },
                        "o": {
                            "x": 0.167,
                            "y": 0.167
                        },
                        "t": 0,
                        "s": [{
                            "i": [
                                [0, 0],
                                [0, 0]
                            ],
                            "o": [
                                [0, 0],
                                [0, 0]
                            ],
                            "v": [
                                [45.125, 0],
                                [45, 0]
                            ],
                            "c": false
                        }]
                    }, {
                        "i": {
                            "x": 0.667,
                            "y": 1
                        },
                        "o": {
                            "x": 0.167,
                            "y": 0.167
                        },
                        "t": 53,
                        "s": [{
                            "i": [
                                [0, 0],
                                [0, 0]
                            ],
                            "o": [
                                [0, 0],
                                [0, 0]
                            ],
                            "v": [
                                [0, 0],
                                [45, 0]
                            ],
                            "c": false
                        }]
                    }, {
                        "i": {
                            "x": 0,
                            "y": 1
                        },
                        "o": {
                            "x": 0.333,
                            "y": 0
                        },
                        "t": 439,
                        "s": [{
                            "i": [
                                [0, 0],
                                [0, 0]
                            ],
                            "o": [
                                [0, 0],
                                [0, 0]
                            ],
                            "v": [
                                [0, 0],
                                [45, 0]
                            ],
                            "c": false
                        }]
                    }, {
                        "i": {
                            "x": 0.833,
                            "y": 1
                        },
                        "o": {
                            "x": 0.167,
                            "y": 0
                        },
                        "t": 478,
                        "s": [{
                            "i": [
                                [0, 0],
                                [0, 0]
                            ],
                            "o": [
                                [0, 0],
                                [0, 0]
                            ],
                            "v": [
                                [0, 0],
                                [70, 0]
                            ],
                            "c": false
                        }]
                    }, {
                        "i": {
                            "x": 0,
                            "y": 1
                        },
                        "o": {
                            "x": 0.333,
                            "y": 0
                        },
                        "t": 521,
                        "s": [{
                            "i": [
                                [0, 0],
                                [0, 0]
                            ],
                            "o": [
                                [0, 0],
                                [0, 0]
                            ],
                            "v": [
                                [0, 0],
                                [70, 0]
                            ],
                            "c": false
                        }]
                    }, {
                        "i": {
                            "x": 0.833,
                            "y": 1
                        },
                        "o": {
                            "x": 0.333,
                            "y": 0
                        },
                        "t": 560,
                        "s": [{
                            "i": [
                                [0, 0],
                                [0, 0]
                            ],
                            "o": [
                                [0, 0],
                                [0, 0]
                            ],
                            "v": [
                                [0, 0],
                                [45, 0]
                            ],
                            "c": false
                        }]
                    }, {
                        "i": {
                            "x": 0.833,
                            "y": 0.833
                        },
                        "o": {
                            "x": 0.167,
                            "y": 0
                        },
                        "t": 1442,
                        "s": [{
                            "i": [
                                [0, 0],
                                [0, 0]
                            ],
                            "o": [
                                [0, 0],
                                [0, 0]
                            ],
                            "v": [
                                [0, 0],
                                [45, 0]
                            ],
                            "c": false
                        }]
                    }, {
                        "i": {
                            "x": 0,
                            "y": 1
                        },
                        "o": {
                            "x": 0.167,
                            "y": 0.167
                        },
                        "t": 1443,
                        "s": [{
                            "i": [
                                [0, 0],
                                [0, 0]
                            ],
                            "o": [
                                [0, 0],
                                [0, 0]
                            ],
                            "v": [
                                [45.125, 0],
                                [45, 0]
                            ],
                            "c": false
                        }]
                    }, {
                        "i": {
                            "x": 0.667,
                            "y": 1
                        },
                        "o": {
                            "x": 0.167,
                            "y": 0.167
                        },
                        "t": 1496,
                        "s": [{
                            "i": [
                                [0, 0],
                                [0, 0]
                            ],
                            "o": [
                                [0, 0],
                                [0, 0]
                            ],
                            "v": [
                                [0, 0],
                                [45, 0]
                            ],
                            "c": false
                        }]
                    }, {
                        "i": {
                            "x": 0,
                            "y": 1
                        },
                        "o": {
                            "x": 0.333,
                            "y": 0
                        },
                        "t": 1572,
                        "s": [{
                            "i": [
                                [0, 0],
                                [0, 0]
                            ],
                            "o": [
                                [0, 0],
                                [0, 0]
                            ],
                            "v": [
                                [0, 0],
                                [45, 0]
                            ],
                            "c": false
                        }]
                    }, {
                        "i": {
                            "x": 0.833,
                            "y": 1
                        },
                        "o": {
                            "x": 0.167,
                            "y": 0
                        },
                        "t": 1611,
                        "s": [{
                            "i": [
                                [0, 0],
                                [0, 0]
                            ],
                            "o": [
                                [0, 0],
                                [0, 0]
                            ],
                            "v": [
                                [0, 0],
                                [70, 0]
                            ],
                            "c": false
                        }]
                    }, {
                        "i": {
                            "x": 0,
                            "y": 1
                        },
                        "o": {
                            "x": 0.333,
                            "y": 0
                        },
                        "t": 1654,
                        "s": [{
                            "i": [
                                [0, 0],
                                [0, 0]
                            ],
                            "o": [
                                [0, 0],
                                [0, 0]
                            ],
                            "v": [
                                [0, 0],
                                [70, 0]
                            ],
                            "c": false
                        }]
                    }, {
                        "t": 1693,
                        "s": [{
                            "i": [
                                [0, 0],
                                [0, 0]
                            ],
                            "o": [
                                [0, 0],
                                [0, 0]
                            ],
                            "v": [
                                [0, 0],
                                [45, 0]
                            ],
                            "c": false
                        }]
                    }],
                    "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
            }, {
                "ty": "st",
                "c": {
                    "a": 0,
                    "k": [1, 1, 1, 1],
                    "ix": 3
                },
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 4
                },
                "w": {
                    "a": 0,
                    "k": 3,
                    "ix": 5
                },
                "lc": 2,
                "lj": 2,
                "bm": 0,
                "nm": "Stroke 1",
                "mn": "ADBE Vector Graphic - Stroke",
                "hd": false
            }, {
                "ty": "tr",
                "p": {
                    "a": 0,
                    "k": [0, 0],
                    "ix": 2
                },
                "a": {
                    "a": 0,
                    "k": [0, 0],
                    "ix": 1
                },
                "s": {
                    "a": 0,
                    "k": [100, 100],
                    "ix": 3
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 6
                },
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 7
                },
                "sk": {
                    "a": 0,
                    "k": 0,
                    "ix": 4
                },
                "sa": {
                    "a": 0,
                    "k": 0,
                    "ix": 5
                },
                "nm": "Transform"
            }],
            "nm": "Shape 253",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
        }],
        "ip": 0,
        "op": 3499,
        "st": -101,
        "bm": 0
    }],
    "markers": []
}